// Migrated 1:1 from @nexato/nx-core-module (lib/label/components/label.component.ts), #672.
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { Label } from '../../entities/label/label';

@Component({
  selector: 'app-label',
  template: `
    <div class="inline-flex items-center text-[12px] border rounded-md overflow-hidden hover:shadow-sm transition-shadow h-5" [style.border-color]="label().color">
      <span class="px-2 py-1 font truncate max-w-[100px]"
            [style.background-color]="label().color"
            [style.color]="contrastColor()"
            [pTooltip]="label()?.scope ? label()?.scope : label()?.name"
            tooltipPosition="top">
        {{label()?.scope ? label()?.scope : label()?.name}}
      </span>
      @if (label()?.scope) {
        <span class="px-2 py-1 bg-white text-gray-800 truncate max-w-[100px]"
              [pTooltip]="label()?.name"
              tooltipPosition="top">
          {{label()?.name}}
        </span>
      }
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LabelComponent {

  readonly label = input.required<Label>();

  readonly contrastColor = computed(() => {
    const color = this.label()?.color;
    if (!color) return '#ffffff';

    const rgb = this.hexToRgb(color);
    if (!rgb) return '#ffffff';

    const luminance = (0.299 * rgb.r + 0.587 * rgb.g + 0.114 * rgb.b) / 255;
    return luminance > 0.5 ? '#000000' : '#ffffff';
  });

  private hexToRgb(hex: string): { r: number; g: number; b: number } | null {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    } : null;
  }
}
